import Button from "@material-ui/core/Button";
import Card from "@material-ui/core/Card";
import AppHeader from "@saleor/components/AppHeader";
import FilterBar from "@saleor/components/FilterBar";
import { CornermarkList_cornerMarks_edges_node } from "@saleor/cornermarks/types/CornermarkList";
import { CornermarkListUrlSortField } from "@saleor/cornermarks/urls";
import { sectionNames } from "@saleor/intl";
import React from "react";
import { FormattedMessage, useIntl } from "react-intl";

import Container from "../../../components/Container";
import PageHeader from "../../../components/PageHeader";
import {
  FilterPageProps,
  ListActions,
  PageListProps,
  SortPage,
  TabPageProps
} from "../../../types";
import CornermarkList from "../CornermarkList";
import {
  CornermarkFilterKeys,
  CornermarkListFilterOpts,
  createFilterStructure
} from "./filters";

export interface CornermarkListPageProps
  extends PageListProps,
    ListActions,
    FilterPageProps<CornermarkFilterKeys, CornermarkListFilterOpts>,
    SortPage<CornermarkListUrlSortField>,
    TabPageProps {
  cornermarks: CornermarkList_cornerMarks_edges_node[];
  toatlCount:number;
  onBack: () => void;
}

const CornermarkListPage: React.FC<CornermarkListPageProps> = ({
  currencySymbol,
  filterOpts,
  initialSearch,
  onAdd,
  onBack,
  onFilterChange,
  onSearchChange,
  currentTab,
  onAll,
  onTabChange,
  onTabDelete,
  onTabSave,
  tabs,
  toatlCount,
  ...listProps
}) => {
  const intl = useIntl();

  const structure = createFilterStructure(intl, filterOpts);

  return (
    <Container>
      <AppHeader onBack={onBack}>
        <FormattedMessage {...sectionNames.configuration} />
      </AppHeader>
      <PageHeader title={intl.formatMessage(sectionNames.cornermarks)+"("+toatlCount+")"}>
        <Button onClick={onAdd} color="primary" variant="contained">
          <FormattedMessage
            defaultMessage="Create Cornermark"
            description="button"
          />
        </Button>
      </PageHeader>
      <Card>
        <FilterBar
          allTabLabel={intl.formatMessage({
            defaultMessage: "All Cornermarks",
            description: "tab name"
          })}
          currencySymbol={currencySymbol}
          currentTab={currentTab}
          filterStructure={structure}
          initialSearch={initialSearch}
          searchPlaceholder={intl.formatMessage({
            defaultMessage: "Search Cornermark..."
          })}
          tabs={tabs}
          onAll={onAll}
          onFilterChange={onFilterChange}
          onSearchChange={onSearchChange}
          onTabChange={onTabChange}
          onTabDelete={onTabDelete}
          onTabSave={onTabSave}
        />
        <CornermarkList {...listProps} />
      </Card>
    </Container>
  );
};
export default CornermarkListPage;
